import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { TranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, TranslationModule],
})
export class HeaderComponent {
  header = input<string>();

  subHeader = input<string>();

  titleClass = input<string>('is-size-3');

  subtitleClass = input<string>('is-size-5');

  isCentered = input(false, { transform: booleanAttribute });
}
